import React, { useState } from "react";
import UserProfile from "./UserProfile";
import ChatScreen from "./chatscreen";

const ChatWindow = ({ chat }) => {
  const [showProfile, setShowProfile] = useState(false);

  return (
    <div className="flex-1 border rounded-3xl !border-[#00000080] p-2">
      {showProfile ? (
        <UserProfile chat={chat} onBack={() => setShowProfile(false)} />
      ) : (
        <ChatScreen chat={chat} onNameClick={() => setShowProfile(true)} />
      )}
    </div>
  );
};

export default ChatWindow;
